import React, { lazy } from 'react';
import { dashboardMenu, demoPages } from '../menu';
import Login from '../pages/presentation/auth/Login';
import Forgot from '../pages/common/Forgot/forgot';
import Changepw from '../pages/common/Changepw/changepw';

const Dashboard = lazy(() => import('../pages/dashboard/DashboardPage'));
const AdminList = lazy(() => import('../pages/common/CommonAdminlist'));
const BusinessList = lazy(() => import('../pages/presentation/demo-pages/ManageBiz'));
const PackageList = lazy(() => import('../pages/presentation/demo-pages/ManagePack'));
const InvoiceList = lazy(() => import('../pages/presentation/demo-pages/ManageInv'));
const ReferralAgentList = lazy(() =>
	import('../pages/presentation/demo-pages/ManageReferralAgent'),
);

const contents = [
	{ path: dashboardMenu.dashboard.path, element: <Dashboard />, exact: true },
	{ path: demoPages.Manage_v.path, element: <AdminList />, exact: true },
	{ path: demoPages.Managebiz.path, element: <BusinessList />, exact: true },
	{ path: demoPages.Packages.path, element: <PackageList />, exact: true },
	{ path: demoPages.Manageinv.path, element: <InvoiceList />, exact: true },
	{ path: demoPages.ManageReferral.path, element: <ReferralAgentList />, exact: true },
	{ path: demoPages.login.path, element: <Login />, exact: true },
	{ path: demoPages.signUp.path, element: <Login isSignUp />, exact: true },
	{ path: demoPages.forgot.path, element: <Forgot />, exact: true },
	{ path: demoPages.changepw.path, element: <Changepw />, exact: true },
];

export default contents;
